import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

import { ComparisonData, ComparisonDelta } from '../tool-content.model';

/**
 * Renders a side-by-side comparison card with metric deltas between two data slices.
 */
@Component({
  selector: 'app-ai-comparison',
  imports: [TranslocoModule],
  templateUrl: './ai-comparison.component.html',
  styleUrls: ['./ai-comparison.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiComparisonComponent {
  readonly data = input.required<ComparisonData>();

  protected readonly title = computed(() => this.data().title);
  protected readonly sliceALabel = computed(() => this.data().sliceA.label);
  protected readonly sliceBLabel = computed(() => this.data().sliceB.label);
  protected readonly deltas = computed(() => this.data().deltas);
  protected readonly hasDeltas = computed(() => this.deltas().length > 0);

  protected deltaClass(delta: ComparisonDelta): string {
    if (delta.delta > 0) {
      return 'ai-comparison__delta--positive';
    }
    if (delta.delta < 0) {
      return 'ai-comparison__delta--negative';
    }
    return 'ai-comparison__delta--neutral';
  }

  protected formatDelta(delta: ComparisonDelta): string {
    const sign = delta.delta > 0 ? '+' : '';
    const value = this.formatNumber(delta.delta);
    if (delta.percentChange != null) {
      const pctSign = delta.percentChange > 0 ? '+' : '';
      return `${sign}${value} (${pctSign}${delta.percentChange.toFixed(1)}%)`;
    }
    return `${sign}${value}`;
  }

  protected formatNumber(value: number): string {
    if (Number.isInteger(value)) {
      return value.toLocaleString();
    }
    return value.toFixed(2);
  }
}
